import { usersService } from '@/services/api/users.service'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../queryKeys'

async function getUsers() {
  const response = await usersService.getAllUsersInAccount()
  return response.data
}

export function useGetUsers() {
  return useQuery({
    queryKey: [QUERY_KEYS.users.getAll],
    queryFn: getUsers,
  })
}
